import { removeNull, annotateMultiEntryPersons } from '@/utils/handleData.js'
import {
  decimalAdd,
  decimalMul,
  decimalSub,
  roundMoney,
  roundMoneyFields,
  formatMoney
} from '@/utils/getCalculatedValue.js'
import {
  isPayslipExitBlocked,
  listYearMonths
} from '@/utils/laborExitSalaryGate.js'
import { getLaborParentBidUid } from '@/utils/bidLevelActions.js'
export default {
  namespaced: true,
  state: {
    payrollIsSure: '未确认',
    payrollList: [], // 某机构工资单列表
    payslipList: [], // 劳务公司工资单明细(工资条列表)
    orgStatistics: {}, // 机构薪酬发放统计
    payslipStatistics: {}, // 单个劳务公司工资单统计
    payslip: {} // 某劳务人员工资条详情
  },
  getters: {
    getTagData: (state) => {
      return function (month, step, orgCode) {
        var tagData = {}
        var payStatistics = {}
        if (step === 'payrollList') {
          payStatistics = state.orgStatistics
        } else if (step === 'payslipList') {
          payStatistics = state.payslipStatistics
        }
        if (
          !Object.keys(payStatistics).length ||
          payStatistics.cumuShouldPay === null
        ) {
          tagData.tagInfo =
            '当前查询条件未查询到数据或查询失败,请改变查询条件或查找问题后再次查询'
          tagData.tagType = 'danger'
          return tagData
        }
        const monthTime = new Date(month)
        const currentShould = roundMoney(payStatistics.currentShouldPay)
        const replacePay = roundMoney(payStatistics.replacePay)
        const currentActual = roundMoney(payStatistics.currentActualPay)
        const monthActual = roundMoney(replacePay + currentActual)
        const cumuShould = roundMoney(payStatistics.cumuShouldPay)
        const cumuActual = roundMoney(payStatistics.cumuActualPay)
        const cumuOwe = roundMoney(cumuShould - cumuActual)
        tagData.tagInfo =
          (payStatistics.orgCode ? payStatistics.orgCode : orgCode) +
          '\xa0' +
          monthTime.getFullYear() +
          '年' +
          (monthTime.getMonth() + 1) +
          '月' +
          '\xa0应发\xa0' +
          formatMoney(currentShould) +
          '\xa0元，补发\xa0' +
          formatMoney(replacePay) +
          '\xa0元，实发\xa0' +
          formatMoney(monthActual) +
          '\xa0元；累计应发\xa0' +
          formatMoney(cumuShould) +
          '\xa0元，累计实发\xa0' +
          formatMoney(cumuActual) +
          '\xa0元，累计欠发\xa0' +
          formatMoney(cumuOwe) +
          '\xa0元，累计发放率\xa0' +
          payStatistics.total +
          '%'
        tagData.tagType = ''
        return tagData
      }
    }
  },
  actions: {
    // 导入工资表
    async upLoadPayslips({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/salary/importSalary',
          data: data,
          msg: '导入工资表成功'
        },
        { root: true }
      )
      return res
    },
    // 获取工资单列表及机构薪酬统计
    async getPayrolls({ dispatch }) {
      await dispatch('getPayrollList')
      await dispatch('getOrgStatistics')
    },
    // 获取工资条列表及单个机构薪酬统计
    async getPayslips({ commit, rootState, dispatch }, data) {
      var queryValues = {}
      if (data && typeof data === 'object') {
        queryValues = {
          upVproUid: data.vProjectUid,
          downVproUid: data.laborTeamUid,
          laborCompanyName: data.laborTeamName,
          teamUid: '',
          monthTime: data.period,
          personName: ''
        }
        commit(
          'queryValuesSet',
          { key: 'payslip', value: queryValues },
          { root: true }
        )
        commit('pageSet', { key: 'payslip', value: 1 }, { root: true })
        dispatch('contractor/getTeamNames', data.laborTeamUid, { root: true })
      }
      commit(
        'limitSet',
        { key: 'payslip', value: !data ? rootState.limit.payslip : null },
        { root: true }
      )
      dispatch('getPayslipStatistics')
      const payslipList = await dispatch('getPayslipList')
      return payslipList
    },
    // 确认薪酬：工资条列表按勾选批量确认；工资单列表行内确认整月全员
    async confirmPayroll({ rootState, dispatch }, params) {
      const step =
        (rootState.currentStep && rootState.currentStep.step) ||
        (rootState.currentTab && rootState.currentTab.step) ||
        ''
      if (step === 'payslipList') {
        const selection =
          (rootState.selection && rootState.selection.payslip) || []
        const pending = selection.filter((item) => {
          return (
            item &&
            item.uid &&
            (item.payStatus === '已结算，待确认' ||
              item.isConf === '2' ||
              item.isConf === 2)
          )
        })
        if (!pending.length) {
          return {
            code: 400,
            msg: '请勾选已结算、待确认的工资条后再确认'
          }
        }
        return await dispatch(
          'baseRequest',
          {
            method: 'POST',
            url: '/organize/salary/confirm',
            data: { uids: pending.map((item) => item.uid) },
            msg: '确认薪酬成功'
          },
          { root: true }
        )
      }
      // 工资单列表：默认确认该劳务公司当月全部待确认工资条
      var data = {
        orgUid: params.laborTeamUid ? params.laborTeamUid : params.downVproUid,
        date: params.period ? params.period + '-01' : params.monthTime + '-01'
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/rule/agree/salary',
          data: data,
          msg: '确认薪酬成功'
        },
        { root: true }
      )
      return res
    },
    // websalarylist 后端限制 limit<=1000，超出直接返回错误串
    async fetchWebSalaryListPage({ dispatch }, query) {
      const pageSize = Math.min(Number(query.limit) || 1000, 1000)
      let page = Number(query.page) || 1
      const all = []
      let guard = 0
      while (guard < 50) {
        guard += 1
        const res = await dispatch(
          'baseRequest',
          {
            method: 'GET',
            url: '/udf/salary/websalarylist',
            data: removeNull(
              Object.assign({}, query, { page: page, limit: pageSize })
            ),
            noErrorMsg: true
          },
          { root: true }
        )
        const data = res && res.data
        if (!data || typeof data !== 'object' || !Array.isArray(data.result)) {
          break
        }
        all.push.apply(all, data.result)
        const total = Number(data.totalSize)
        if (
          !data.result.length ||
          data.result.length < pageSize ||
          (Number.isFinite(total) && all.length >= total)
        ) {
          break
        }
        page += 1
      }
      return all
    },
    // 查询某劳务公司某月未结算人员姓名（工资单整月确认前置校验）
    async getUnsettledPayslipNames({ rootState, dispatch }, data) {
      const list = await dispatch('fetchWebSalaryListPage', {
        upVproUid:
          data.upVproUid ||
          (rootState.queryValues.payroll &&
            rootState.queryValues.payroll.upVproUid) ||
          '',
        downVproUid: data.downVproUid || data.laborTeamUid || '',
        monthTime: data.monthTime || data.period || '',
        teamUid: '',
        personName: '',
        page: 1,
        limit: 1000
      })
      return list
        .filter((item) => {
          // 未结算 / 考勤未确认（尚未形成可确认工资条）
          const settled = item.isPay === '已结算' || item.isPay === true
          return !settled
        })
        .map((item) => item.name || item.personName)
        .filter((name) => !!name)
    },
    /**
     * 批量退场前置：选中人员在进场月至当前月是否存在未结算/未确认工资条。
     * 返回需提示的人员姓名（去重）。
     */
    async getExitBlockedPayslipNames({ rootState, dispatch }, data) {
      const laborTeamUid = data.laborTeamUid || data.downVproUid || ''
      const personUids = (data.personUids || [])
        .map((uid) => String(uid || '').trim())
        .filter(Boolean)
      const entryUids = (data.entryUids || [])
        .map((uid) => String(uid || '').trim())
        .filter(Boolean)
      const nameMap = data.personNameMap || {}
      const nameSet = {}
      Object.keys(nameMap).forEach((uid) => {
        const n = String(nameMap[uid] || '').trim()
        if (n) nameSet[n] = uid
      })
      ;(data.personNames || []).forEach((n) => {
        const name = String(n || '').trim()
        if (name && !nameSet[name]) nameSet[name] = name
      })
      if (
        !laborTeamUid ||
        (!personUids.length &&
          !entryUids.length &&
          !Object.keys(nameSet).length)
      ) {
        return []
      }
      const personSet = {}
      personUids.forEach((uid) => {
        personSet[uid] = true
      })
      const entrySet = {}
      entryUids.forEach((uid) => {
        entrySet[uid] = true
      })
      const months = listYearMonths(
        data.fromDate || data.walkinDate,
        data.toDate || data.walkoffDate || new Date()
      )
      if (!months.length) return []
      const blocked = {}
      const markBlocked = (item, fallbackName) => {
        if (!item || !isPayslipExitBlocked(item)) return false
        const uid = String(
          item.personUid || item.person_uid || item.PERSONUID || ''
        ).trim()
        const entryUid = String(
          item.pEntryUid ||
            item.p_entry_uid ||
            item.entryUid ||
            item.laborUid ||
            ''
        ).trim()
        const name = String(
          item.name || item.personName || fallbackName || ''
        ).trim()
        const hitUid = uid && personSet[uid]
        const hitEntry = entryUid && entrySet[entryUid]
        const hitName = name && nameSet[name]
        if (!hitUid && !hitEntry && !hitName) return false
        const key = uid || entryUid || name
        blocked[key] = name || nameMap[uid] || blocked[key] || uid || name
        return true
      }
      const upCandidates = []
      const pushUp = (uid) => {
        const v = uid ? String(uid).trim() : ''
        if (v && upCandidates.indexOf(v) === -1) upCandidates.push(v)
      }
      pushUp(data.upVproUid)
      pushUp(
        rootState.queryValues.laborPerson &&
          rootState.queryValues.laborPerson.vProjectUid
      )
      pushUp(
        rootState.queryValues.payroll &&
          rootState.queryValues.payroll.upVproUid
      )
      pushUp(
        rootState.queryValues.payslip &&
          rootState.queryValues.payslip.upVproUid
      )
      // 列表接口依赖标段；逐个标段汇总，避免错标段提前打断
      for (let i = 0; i < months.length; i++) {
        const monthTime = months[i]
        const seen = {}
        for (let u = 0; u < upCandidates.length; u++) {
          const list = await dispatch('fetchWebSalaryListPage', {
            upVproUid: upCandidates[u],
            downVproUid: laborTeamUid,
            monthTime,
            teamUid: '',
            personName: '',
            page: 1,
            limit: 1000
          })
          list.forEach((item) => {
            const uid = String(
              item.personUid || item.person_uid || item.PERSONUID || ''
            ).trim()
            const entryUid = String(
              item.pEntryUid || item.p_entry_uid || item.entryUid || ''
            ).trim()
            const dedupe = uid || entryUid || String(item.uid || '')
            if (dedupe && seen[dedupe]) return
            if (dedupe) seen[dedupe] = true
            markBlocked(item)
          })
        }
      }
      // 列表未命中时，按人员明细兜底（不依赖标段参数）
      const unresolvedUids = personUids.filter((uid) => !blocked[uid])
      for (let p = 0; p < unresolvedUids.length; p++) {
        const personUid = unresolvedUids[p]
        const personName = String(nameMap[personUid] || '').trim()
        for (let i = 0; i < months.length; i++) {
          const res = await dispatch(
            'baseRequest',
            {
              method: 'GET',
              url: '/udf/salary/persondetail',
              data: {
                downVproUid: laborTeamUid,
                personUid,
                monthTime: months[i]
              },
              noErrorMsg: true
            },
            { root: true }
          )
          const slip =
            res && res.data && typeof res.data === 'object' ? res.data : null
          if (!slip || !Object.keys(slip).length) continue
          if (!slip.personUid) slip.personUid = personUid
          if (!slip.name && personName) slip.name = personName
          if (markBlocked(slip, personName)) break
        }
      }
      return Object.keys(blocked).map((uid) => blocked[uid])
    },
    // 查询缺银行卡人员（确认前置：需先补进场银行卡）
    async getMissingBankPayslipNames({ rootState, dispatch }, data) {
      const list = await dispatch('fetchWebSalaryListPage', {
        upVproUid:
          data.upVproUid ||
          (rootState.queryValues.payroll &&
            rootState.queryValues.payroll.upVproUid) ||
          '',
        downVproUid: data.downVproUid || data.laborTeamUid || '',
        monthTime: data.monthTime || data.period || '',
        teamUid: '',
        personName: '',
        page: 1,
        limit: 1000
      })
      return list
        .filter((item) => {
          if (data.onlyPendingConfirm) {
            const settled = item.isPay === '已结算' || item.isPay === true
            const pending =
              item.isConf === '2' || item.isConf === 2 || item.isConf === '待确认'
            if (!(settled && pending)) return false
          }
          const card = String(item.bankCard || item.bank_card || '').trim()
          return !card
        })
        .map((item) => item.name || item.personName)
        .filter((name) => !!name)
    },
    // 查询机构某月薪酬是否确认
    async getPayrollIsSure({ commit, rootState, dispatch }) {
      var data = {
        orgUid: rootState.queryValues.payslip.downVproUid,
        date: rootState.queryValues.payslip.monthTime
      }
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/organize/isagree/salary', data: data },
        { root: true }
      )
      if (res.data && res.data.isConf) {
        commit(
          'baseSet',
          { module: 'salaryPay', key: 'payrollIsSure', value: res.data.isConf },
          { root: true }
        )
      }
    },
    // 获取机构工资单列表
    async getPayrollList({ rootState, rootGetters, commit, dispatch }) {
      var queryValues = await dispatch(
        'bidSection/ensureDefaultBidQuery',
        { queryKey: 'payroll', fieldKey: 'upVproUid' },
        { root: true }
      )
      queryValues = Object.assign({}, queryValues)
      // 劳务公司：强制按所属标段 + 本公司查询（alllist 依赖 upVproUid）
      const orgType = rootGetters['user/orgType']
      const orgValue = rootState.user && rootState.user.orgValue
      if (orgType === 'laborCom' && orgValue) {
        const bidUid = getLaborParentBidUid({
          orgType,
          orgValue,
          state: rootState,
          getters: rootGetters
        })
        if (bidUid) queryValues.upVproUid = bidUid
        queryValues.downVproUid = orgValue
        commit(
          'queryValuesSet',
          { key: 'payroll', value: Object.assign({}, queryValues) },
          { root: true }
        )
      }
      queryValues.page = rootState.page.payroll
      queryValues.limit = rootState.limit.payroll
      queryValues = removeNull(queryValues)
      const emptyList = { result: [], totalSize: 0 }
      if (!queryValues.upVproUid) {
        commit(
          'baseSet',
          { module: 'salaryPay', key: 'payrollList', value: emptyList },
          { root: true }
        )
        return emptyList
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/udf/salary/alllist',
          data: queryValues,
          noErrorMsg: true
        },
        { root: true }
      )
      var payrollList =
        res && res.data && typeof res.data === 'object' ? res.data : emptyList
      payrollList.result = Array.isArray(payrollList.result)
        ? payrollList.result
        : []
      if (payrollList.totalSize == null) {
        payrollList.totalSize = payrollList.result.length
      }
      payrollList.result.forEach((item) => {
        roundMoneyFields(item)
        item.period = queryValues.monthTime
        item.actualPay = roundMoney(
          roundMoney(item.currentActualPay) + roundMoney(item.replacePay)
        )
        item.total = item.total + '%'
        item.settlementProgress = item.payNum + '\xa0/\xa0' + item.sumNum
        item.confirmProgress = item.confNum + '\xa0/\xa0' + item.payNum
        item.disabledButtons = []
        if (queryValues.upVproUid !== rootState.user.orgValue) {
          item.disabledButtons = ['', 1, 2]
        }
        if (item.confNum >= item.payNum && item.payNum !== 0) {
          item.disabledButtons = ['', 1, '']
        }
      })
      commit(
        'baseSet',
        { module: 'salaryPay', key: 'payrollList', value: payrollList },
        { root: true }
      )
      return payrollList
    },
    // 获取劳务公司工资单明细
    async getPayslipList({ rootState, commit, dispatch }) {
      var queryValues = rootState.queryValues.payslip
      queryValues.page = rootState.page.payslip
      queryValues.limit = rootState.limit.payslip
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/udf/salary/websalarylist', data: queryValues },
        { root: true }
      )
      var payslipList = res.data ? res.data : []
      payslipList.result = payslipList.result || []
      payslipList.result.forEach((item) => {
        roundMoneyFields(item)
        item.disabledButtons = []
        const calcNum = parseFloat(item.calculateNum)
        item.calculateNum = Number.isFinite(calcNum) ? calcNum.toFixed(2) : ''
        if (!item.contractEffectiveTime) {
          item.contractEffectiveTime = ''
        }
        item.actualPay = roundMoney(
          roundMoney(item.currentActualPay) + roundMoney(item.replacePay)
        )
        item.isPay = item.isPay === '已结算' ? true : false
        if (!item.isPay) {
          item.payStatus = '未结算'
          item.disabledButtons = ['', '', 2]
        } else if (item.isPay && item.isConf === '2') {
          item.disabledButtons = ['', 1, '']
          item.payStatus = '已结算，待确认'
        } else if (item.isPay && item.isConf === '1') {
          item.disabledButtons = ['', 1, 2]
          item.payStatus = '薪酬已确认'
        } else if (item.isPay && item.isConf === '0') {
          item.disabledButtons = ['', 1, '']
          item.payStatus = '已结算，被拒绝'
        }
        if (item.isConfClock === '0') {
          item.payStatus = '考勤未确认'
          item.disabledButtons = ['', 1, 2]
        }
        if (item.vProjectUid !== rootState.user.orgValue) {
          item.disabledButtons = ['', 1, 2]
        }
        const refuseRaw = String(
          item.refuseMark ||
            item.refuse_mark ||
            item.agreeType ||
            item.agree_type ||
            item.mark ||
            ''
        ).trim()
        item.refuseMark = refuseRaw.replace(/^个人拒绝[:：]?/, '')
        const badges = []
        const bankCard = String(
          item.bankCard || item.bank_card || item.cardNum || item.card_num || ''
        ).trim()
        const signatureUid = String(
          item.signatureUid || item.signature_uid || item.signUid || ''
        ).trim()
        if (!String(item.contractEffectiveTime || '').trim()) {
          badges.push('无合同')
        }
        if (!bankCard) badges.push('缺银行卡')
        if (!signatureUid) badges.push('缺签名')
        item.nameBadges = badges
      })
      annotateMultiEntryPersons(payslipList.result, {
        nameKey: 'name',
        personKey: 'personUid',
        entryKey: 'pEntryUid'
      })
      payslipList.result.forEach((item) => {
        if (item.entrySeq > 0 && item.entryPeriodLabel) {
          item.nameBadges = (item.nameBadges || []).concat([
            '进场段' + item.entrySeq + ' ' + item.entryPeriodLabel
          ])
        }
        if (!item.nameDisplay) item.nameDisplay = item.name
        if (!item.nameBase) item.nameBase = item.name
      })
      commit(
        'baseSet',
        { module: 'salaryPay', key: 'payslipList', value: payslipList },
        { root: true }
      )
      if (!rootState.limit.payslip) {
        commit(
          'limitSet',
          { key: 'payslip', value: res.data.totalSize },
          { root: true }
        )
      }
      commit('selectionSet', { key: 'payslip', value: [] }, { root: true })
      return payslipList
    },
    // 获取机构薪酬发放统计
    async getOrgStatistics({ rootState, rootGetters, commit, dispatch }) {
      var queryValues = Object.assign({}, rootState.queryValues.payroll || {})
      const orgType = rootGetters['user/orgType']
      const orgValue = rootState.user && rootState.user.orgValue
      if (orgType === 'laborCom' && orgValue) {
        const bidUid = getLaborParentBidUid({
          orgType,
          orgValue,
          state: rootState,
          getters: rootGetters
        })
        if (bidUid) queryValues.upVproUid = bidUid
        queryValues.downVproUid = orgValue
      }
      queryValues = removeNull(queryValues)
      if (!queryValues.upVproUid) {
        commit(
          'baseSet',
          { module: 'salaryPay', key: 'orgStatistics', value: {} },
          { root: true }
        )
        return {}
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/udf/salary/alltitle',
          data: queryValues,
          noErrorMsg: true
        },
        { root: true }
      )
      if (res && res.data && typeof res.data === 'object') {
        commit(
          'baseSet',
          {
            module: 'salaryPay',
            key: 'orgStatistics',
            value: roundMoneyFields(res.data)
          },
          { root: true }
        )
        return res.data
      }
      commit(
        'baseSet',
        { module: 'salaryPay', key: 'orgStatistics', value: {} },
        { root: true }
      )
      return {}
    },
    // 获取单个劳务公司工资单统计
    async getPayslipStatistics({ rootState, commit, dispatch }) {
      var queryValues = rootState.queryValues.payslip
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/udf/salary/websalarytitle', data: queryValues },
        { root: true }
      )
      if (res.data) {
        commit(
          'baseSet',
          {
            module: 'salaryPay',
            key: 'payslipStatistics',
            value: roundMoneyFields(res.data)
          },
          { root: true }
        )
      } else {
        commit(
          'baseSet',
          { module: 'salaryPay', key: 'payslipStatistics', value: {} },
          { root: true }
        )
      }
    },
    // 获取劳务公司累计薪酬发放情况
    async getLaborCompanyPay({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/udf/buildtype/cumusalary', data: data },
        { root: true }
      )
      return res && res.data ? res.data : {}
    },
    // 获取劳务人员薪酬发放情况
    async getPayslip({ rootState, commit, dispatch }, params) {
      var data = {
        downVproUid: params.laborTeamUid,
        personUid: params.personUid,
        monthTime: params.period
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/udf/salary/persondetail',
          data: data,
          noErrorMsg: rootState.dialogName === 'upLoadPayslips'
        },
        { root: true }
      )
      var payslip = res.data ? res.data : {}
      if (Object.keys(payslip).length) {
        roundMoneyFields(payslip)
        payslip.actualPay = roundMoney(
          roundMoney(payslip.currentActualPay) + roundMoney(payslip.replacePay)
        )
        payslip.withholdReason = payslip.withholdReason
          ? payslip.withholdReason
          : '/'
        payslip.isPay = payslip.isPay === '未结算' ? false : true
        // 可补发上限：进入本月前累计欠发（后端实时汇总）
        const priorOwe = await dispatch('getPriorOwe', {
          personUid: params.personUid || payslip.personUid,
          laborTeamUid: params.laborTeamUid || payslip.laborTeamUid,
          vProjectUid: payslip.vProjectUid,
          period: params.period || payslip.period
        })
        payslip.maxReplacePay = roundMoney(priorOwe)
      }
      // 未结算基准值写入 store，供结算弹窗改动字段时重算累计
      commit(
        'baseSet',
        {
          module: 'salaryPay',
          key: 'payslip',
          value: Object.keys(payslip).length
            ? JSON.parse(JSON.stringify(payslip))
            : payslip
        },
        { root: true }
      )
      // 仅「结算」进入时按公式默认算实发，供快速结算；未结算列表/查看保持实发为0；已结算直接用结算数据（不看确认）
      const settlementStatus =
        rootState.pageStatus && rootState.pageStatus.settlement
      if (
        Object.keys(payslip).length &&
        !payslip.isPay &&
        settlementStatus === 'add'
      ) {
        const calculateNum = parseFloat(payslip.calculateNum) || 0
        const priceUnit = parseFloat(payslip.priceUnit) || 0
        const overtimePay = roundMoney(payslip.overtimePay)
        const cutPayment = roundMoney(payslip.cutPayment)
        const currentOwePay = roundMoney(payslip.currentOwePay)
        const replacePay = roundMoney(payslip.replacePay)
        payslip.grossPay = roundMoney(
          decimalAdd(
            parseFloat(decimalMul(calculateNum, priceUnit).toFixed(2)),
            overtimePay
          )
        )
        payslip.currentShouldPay = roundMoney(
          decimalSub(payslip.grossPay, cutPayment)
        )
        payslip.currentActualPay = roundMoney(
          decimalSub(payslip.currentShouldPay, currentOwePay)
        )
        payslip.replacePay = replacePay
        payslip.actualPay = roundMoney(
          decimalAdd(payslip.currentActualPay, replacePay)
        )
        payslip.cumuActualPay = roundMoney(
          decimalAdd(
            decimalAdd(
              parseFloat(payslip.cumuActualPay) || 0,
              payslip.currentActualPay
            ),
            replacePay
          )
        )
        payslip.cumuOwePay = roundMoney(
          decimalSub(
            parseFloat(payslip.cumuShouldPay) || 0,
            payslip.cumuActualPay
          )
        )
        roundMoneyFields(payslip)
        // 结算预填后同步回 store，保留 maxReplacePay
        commit(
          'baseSet',
          {
            module: 'salaryPay',
            key: 'payslip',
            value: JSON.parse(JSON.stringify(payslip))
          },
          { root: true }
        )
      }
      return payslip
    },
    // 进入本月前累计欠发（本月可补发上限）
    async getPriorOwe({ dispatch }, params) {
      if (
        !params ||
        !params.personUid ||
        !params.laborTeamUid ||
        !params.vProjectUid ||
        !params.period
      ) {
        return 0
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/salary/priorOwe',
          data: {
            personUid: params.personUid,
            laborTeamUid: params.laborTeamUid,
            vProjectUid: params.vProjectUid,
            period: params.period
          },
          noErrorMsg: true
        },
        { root: true }
      )
      const max = res && res.data != null ? Number(res.data) : 0
      return isNaN(max) || max < 0 ? 0 : roundMoney(max)
    },
    // 查询人员上月薪酬是否确认
    async getLaborPersonLastConf({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/query/salary/lastisConf', data: data },
        { root: true }
      )
      return res.data ? res.data : 0
    },
    // 个人薪酬结算
    async addPayslip({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/salary/detail',
          data: data,
          msg: '个人薪酬结算成功'
        },
        { root: true }
      )
      return res
    },
    // 个人薪酬批量结算
    async batchAddPayslip({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/salary/details',
          data: data,
          msg: '批量薪酬结算成功'
        },
        { root: true }
      )
      return res
    },
    // 退场办理：管理员确认指定人员某月工资条
    async confirmPersonSalary({ dispatch }, data) {
      const payload = Object.assign({}, data || {}, { isConf: '1' })
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/salary/detail',
          data: payload,
          msg: '确认薪酬成功'
        },
        { root: true }
      )
      return res
    },
    // 个人薪酬再次结算
    async editPayslip({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/salary/detail',
          data: data,
          msg: '个人薪酬结算成功'
        },
        { root: true }
      )
      return res
    }
  }
}
